import TrackButton from '@component/card/listings/track'
import IconTrack from '@icon/house/track.svg'
import { toPrice2 } from '@utils'
import classNames from 'classnames'
import { get } from 'lodash-es'
// import FreeAppraisalButton from './freeAppraisal'
import FindEstimateButton from '../findEstimate/button'

export default function EstimateTrack({
  data
}) {

  const tracked = get(data, 'tracked', false)
  const avmData = get(data, 'avm', false)
  const showAppraisalButton = !data.houseId && !tracked
  const showMedianSalePrice = Boolean(data.medianSalePrice)

  return (
    <aside className={classNames({ 'pt-24': showMedianSalePrice })}>
      <div className='border rounded-sm p-24 flex flex-col gap-y-10 h-full'>
        {
          showMedianSalePrice
            ? (
              <>
                <div className='relative'>
                  <IconTrack className='md:absolute md:-top-48 md:left-1/2 md:-translate-x-1/2 mx-auto block' />
                </div>
                <div className='text-center text-base font-bold'>Average sale price in {data.suburb}:</div>
                <div className='text-center text-2xl font-bold'>
                  <span className='inline-block relative pb-10 after:absolute after:bottom-0 after:inset-x-0 after:h-4 after:bg-secondary after:rounded-[100px_100px_0_0]'>${toPrice2(data.medianSalePrice)}</span>
                </div>
                <div className='text-center text-sm font-medium mt-20 md:mt-auto'>
                  {
                    avmData
                      ? 'Get notifications when this property gets a new valuation'
                      : 'Find average asking and sale prices nearby.'
                  }
                </div>
              </>
            )
            : (
              <div className='text-lg leading-20 mb-auto'>
                {
                  tracked
                    ? 'Thanks, we will keep you updated with the latest valuation.'
                    : (
                      data.houseId
                        ? (
                          avmData
                            ? 'Receive free notifications when this property gets a new valuation.'
                            : 'Receive free notifications when this property gets a valuation.'
                        )
                        : 'Interested in this property?'
                    )
                }
              </div>
            )
        }
        {/* {
          showAppraisalButton && (
            <FreeAppraisalButton data={data} />
          )
        } */}
        {
          avmData
            ? (
              <TrackButton
                data={data}
                signupSource='Track_Home'
                className='w-full !text-base'
                dark={showAppraisalButton}
              />
            )
            : <FindEstimateButton data={data} />
        }
      </div>
    </aside>
  )
}